module.exports = {
  // TODO: Figure out which fields are actually needed here then remove the rest from all properties
  gatsbyConfig: {
    property: 'worldofwoodward',
    copyrightTagline: 'World of Woodward',
    siteName: 'World of Woodward',
    siteUrl: 'https://www.worldofwoodward.com/',
    reCaptchaDBPropertyName: 'World of Woodward',
    reCaptchaPublicKey: '6LfiiYIUAAAAAEvSxGg7A_ZOQRemWMgGBoTr0Z5P',
    color: '#64CAC7',
    facebook: 'borealmtn',
    instagram: 'borealmtn',
    twitter: 'borealmtn',
    dynamicTypes: [
      'pressRelease',
      'event',
      'blog',
    ],
    ignore404Routes: [
      '/news',
    ],
    onetrustID: '0196035b-6d9f-742d-806d-d72688b182f0',
  },
};
